import TableHeader from "../../../../core/Table/TableHeader/TableHeader.jsx";
import {PLACE_COLORS, RAKE_RACE_TABLE_TITLES} from "../../../../constants/index.jsx";
import {useSelector} from "react-redux";

function RakeRaceLeaderBoard({rows = [], prizePool = {}, minRoomCount}) {
    const currency = useSelector((state) => state.user.currency);

    const renderRow = (cell, index) => {

        const placeClassName = [0, 1, 2,].includes(index) ? `place ${PLACE_COLORS[index + 1]}` : '';

        return (
            <div key={index + 'desktop'} className="table-body--row">
                {cell?.count >= minRoomCount ?
                    <div className="table-body--cell"><span className={placeClassName}>{index + 1}</span></div> :
                    <div className="table-body--cell">-</div>
                }
                <div className="table-body--cell">{cell?.platformId}</div>
                <div className="table-body--cell">{`${cell?.count} / ${minRoomCount}`}</div>
                <div className="table-body--cell">{cell?.points}</div>
                {cell?.count >= minRoomCount && prizePool?.[index + 1] ?
                    <div className="table-body--cell">
                        {prizePool?.[index + 1]?.[currency]}
                        <span className="currency-small">{currency}</span>
                    </div> :
                    <div className="table-body--cell">-</div>
                }
            </div>
        )
    }

    return (
        <div className="table-wrapper">
            <div className="table">
                <TableHeader columns={RAKE_RACE_TABLE_TITLES}/>
                <div className="table-body">
                    {
                        rows?.map((row, index) => {
                            return renderRow(row, index)
                        })
                    }
                </div>
            </div>
        </div>
    )

}

export default RakeRaceLeaderBoard